// The four points at which an on-stop customer's order is stopped (HFW on stop, Oct 2026).
// Mirrors TMSWeb.Common.Constants.OnStopOverrideStages - the values are stored on each override
// row, so the two must stay in step.
export enum OnStopOverrideStages {
  orderEntry = 'OrderEntry',
  confirm = 'Confirm',
  picking = 'Picking',
  despatch = 'Despatch',
}

// The `code` on an on-stop refusal of an entry, a pick or a despatch note. Mirrors
// TMSWeb.Common.Constants.OnStopRefusalCodes.
export const OnStopRefusalCode = 'OnStop';

// A stage as a person reads it, for the On Stop Overrides list.
export function onStopOverrideStageName(stage: string | undefined | null): string {
  switch (stage) {
    case OnStopOverrideStages.orderEntry:
      return $localize`Order Entry`;
    case OnStopOverrideStages.confirm:
      return $localize`Confirm`;
    case OnStopOverrideStages.picking:
      return $localize`Picking`;
    case OnStopOverrideStages.despatch:
      return $localize`Despatch`;
    default:
      // Anything unrecognised shows as stored rather than vanishing.
      return stage ?? '';
  }
}
